"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAudienceResponseToJSON = exports.DeleteAudienceResponseFromJSONTyped = exports.DeleteAudienceResponseFromJSON = exports.instanceOfDeleteAudienceResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the DeleteAudienceResponse interface.
 */
function instanceOfDeleteAudienceResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDeleteAudienceResponse = instanceOfDeleteAudienceResponse;
function DeleteAudienceResponseFromJSON(json) {
    return DeleteAudienceResponseFromJSONTyped(json, false);
}
exports.DeleteAudienceResponseFromJSON = DeleteAudienceResponseFromJSON;
function DeleteAudienceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deletionCount': !(0, runtime_1.exists)(json, 'deletion_count') ? undefined : json['deletion_count'],
    };
}
exports.DeleteAudienceResponseFromJSONTyped = DeleteAudienceResponseFromJSONTyped;
function DeleteAudienceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'deletion_count': value.deletionCount,
    };
}
exports.DeleteAudienceResponseToJSON = DeleteAudienceResponseToJSON;
